var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"skeleton",attrs:{"data-loading":_vm.loading,"data-visible":_vm.visible}},[(_vm.visible)?_c('div',{key:"skeleton",staticClass:"skeleton-item-wrapper"},[_vm._t("placeholder")],2):_c('div',{key:"content",staticClass:"content-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }